var _rect, _rect2, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgPaperclip = function SvgPaperclip(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 41,
    height: 43,
    fill: "none"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 39.938,
    height: 41.111,
    x: 0.75,
    y: 0.75,
    fill: "#fff",
    rx: 19.969
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 39.938,
    height: 41.111,
    x: 0.75,
    y: 0.75,
    stroke: "#C3C3C3",
    strokeWidth: 0.5,
    rx: 19.969
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#5B3552",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "m30.438 20.662-9.19 9.19a6.003 6.003 0 1 1-8.49-8.49l9.19-9.19a4.003 4.003 0 0 1 5.66 5.66l-9.2 9.19a2 2 0 1 1-2.83-2.83l8.49-8.48"
  })));
};
export { SvgPaperclip as ReactComponent };
export default __webpack_public_path__ + "images/paperclip.svg";